// Roving-tabindex math for the right-sidebar tablist: maps an arrow/Home/End key to the next tab
// index, or null when the key isn't a tab-nav key (so the handler bails). `length` varies — the
// Changes tab drops out when there are no pending suggestions — so the wrap-around is computed
// against the live count, not a constant.
export const nextTabIndex = (key: string, current: number, length: number): number | null => {
  if (length === 0) return null;
  if (key === 'ArrowRight') return (current + 1) % length;
  if (key === 'ArrowLeft') return (current - 1 + length) % length;
  if (key === 'Home') return 0;
  if (key === 'End') return length - 1;
  return null;
};
